import React, { useState, useEffect } from "react";
import { Calendar, momentLocalizer, Views } from "react-big-calendar";
import ExitCalendarCustomToolbar from "./ExitCalendarCustomToolbar";
import moment from "moment";
import "moment/locale/es";
import "react-big-calendar/lib/css/react-big-calendar.css";
import styles from "./ExitCalendar.module.css";
import PersonIcon from "../../assets/svgs/person.svg";

moment.locale("es");
const localizer = momentLocalizer(moment);

const ExitCalendar = ({ data = [], isAdmin, onDaySelect }) => {
    const [calendarEvents, setCalendarEvents] = useState([]);
    const [selectedDate, setSelectedDate] = useState(moment().format("YYYY-MM-DD"));

    useEffect(() => {
        const mapped = (Array.isArray(data) ? data : []).map((item) => ({
            title: `${item.Empleado ?? "—"}`,
            start: moment(item.Fecha).startOf("day").toDate(),
            end: moment(item.Fecha).endOf("day").toDate(),
            color: "#99C643B2",
        }));
        setCalendarEvents(mapped);
    }, [data]);

    const messages = {
        today: "Hoy",
        previous: "Anterior",
        next: "Siguiente",
        month: "Mes",
        week: "Semana",
        showMore: (total) => `${total} más`,
    };

    return (
        <div className={`${styles.calendarContainer} exitCalendarWrapper`}>
            <Calendar
                localizer={localizer}
                events={calendarEvents}
                startAccessor="start"
                endAccessor="end"
                selectable
                onSelectSlot={({ start }) => {
                    const formatted = moment(start).format("YYYY-MM-DD");
                    setSelectedDate(formatted);
                    onDaySelect?.(formatted);
                }}
                onSelectEvent={(event) => {
                    const formatted = moment(event.start).format("YYYY-MM-DD");
                    setSelectedDate(formatted);
                    onDaySelect?.(formatted);
                }}
                dayPropGetter={(date) => {
                    const formatted = moment(date).format("YYYY-MM-DD");
                    const classes = [];
                    if (formatted === selectedDate) classes.push(styles.selectedDay);
                    return { className: classes.join(" ") };
                }}
                style={{ height: "100%" }}
                views={{ month: true }}
                messages={messages}
                defaultView={Views.MONTH}
                components={{
                    toolbar: (toolbarProps) => (
                        <ExitCalendarCustomToolbar {...toolbarProps} isAdmin={isAdmin} />
                    ),
                    event: ({ event }) => (
                        <div className={styles.eventContainer}>
                            <img src={PersonIcon} alt="Empleado" className={styles.eventIcon} />
                            <span className={styles.eventText}>{event.title}</span>
                        </div>
                    ),
                }}
                eventPropGetter={() => ({
                    style: {
                        backgroundColor: "transparent",
                        padding: "1px",
                        marginLeft: "5px",
                        marginBottom: "1px",
                    },
                })}
            />
        </div>
    );
};

export default ExitCalendar;
